import styles from "./Ordered.module.css";
import { Button } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import { SupplierData } from "../Suppliers/SupplierTable";
import { AuthContext, AuthContextType } from "../../Auth";
import { baseUrl } from "../../url";
import { useNavigate } from "react-router-dom";

type product = {
  productname: string;
  left_right: string;
  color: string;
  size: string;
  quantity: number;
  receiveDate: string;
};

type orderedData = {
  office: string;
  order_at: string;
  order_id: number;
  products: product[];
  supplier: string;
};

export default function Ordered() {
  const [suppliers, setSuppliers] = useState<SupplierData[]>([]);
  const [selectedSupplier, setSelectedSupplier] = useState<string>("");
  const [ordered, setOrdered] = useState<orderedData[]>([]);
  const { auth, setAuth } = useContext(AuthContext) as AuthContextType;
  const [selectedOffice, setSelectedOffice] = useState<string>(
    auth.office ? auth.office : ""
  );
  const navigate = useNavigate();
  const [reload, setReload] = useState<boolean>(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${baseUrl}/checkAuth`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (!data.result) {
          console.log("Not authenticated");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        const response2 = await fetch(`${baseUrl}/getusersdata`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: data.username }),
        });
        const data2 = await response2.json();
        console.log(
          "Authenticated user:",
          data.username,
          "Office:",
          data2.office,
          "Authority:",
          data2.authority
        );
        setAuth({
          username: data.username,
          isAuthenticated: true,
          office: data2.office,
          authority: data2.authority,
        });
      } catch (error) {
        console.error(error);
      }
    };
    checkAuth();
  }, [navigate, setAuth]);

  useEffect(() => {
    const fetchSupplier = async () => {
      const response = await fetch(`${baseUrl}/getsupplier`, {
        method: "GET",
        credentials: "include",
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      setSuppliers(data);
    };

    fetchSupplier();
  }, [setAuth, navigate]);

  useEffect(() => {
    const fetchOrderedProduct = async () => {
      const response = await fetch(`${baseUrl}/orderedproduct`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          office: selectedOffice,
          supplier: selectedSupplier,
        }),
      });
      const data = await response.json();
      console.log(data);
      if (data.isAuth === false) {
        alert("セッションが切れました。再度ログインしてください");
        setAuth({
          username: null,
          isAuthenticated: false,
          office: undefined,
          authority: "user",
        });
        return navigate("/login");
      }
      for (let i = 0; i < data.length; i++) {
        const order_at = new Date(data[i].order_at);
        const dayofweek = [
          "（日）",
          "（月）",
          "（火）",
          "（水）",
          "（木）",
          "（金）",
          "（土）",
        ];
        const convert = (dateItem: Date) => {
          const japanOffset = 9 * 60 * 60 * 1000;
          const japanDate = new Date(dateItem.getTime() + japanOffset);
          const year = japanDate.getFullYear();
          const month = japanDate.getMonth() + 1;
          const date = japanDate.getDate();
          const day = dayofweek[japanDate.getDay()];
          const hours = japanDate.getHours();
          const minutes = japanDate.getMinutes();
          const seconds = japanDate.getSeconds();
          const convertDate = {
            date: `${year}年${month}月${date}日${day}`,
            time: `${hours}: ${minutes}: ${seconds}`,
          };
          return convertDate;
        };
        const convertdata = convert(order_at);
        data[i].order_at = convertdata.date + convertdata.time;
        for (let j = 0; data[i].products.length > j; j++) {
          if (data[i].products[j].receiveDate) {
            const utcReceiveDate = new Date(data[i].products[j].receiveDate);
            const convertReceiveDate = convert(utcReceiveDate);
            console.log(convertReceiveDate);
            data[i].products[j].receiveDate = `${convertReceiveDate.date}`;
          } else {
            data[i].products[j].receiveDate = "";
          }
        }
      }
      setOrdered(data);
    };

    fetchOrderedProduct();
  }, [selectedOffice, selectedSupplier, navigate, setAuth, reload]);

  const handleOffice = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOffice(e.target.value);
  };

  const handleSupplier = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedSupplier(e.target.value);
  };

  const orderedEnter = async (index: number) => {
    const enterConform = window.confirm(
      "選択した未入庫分製品の入庫処理を行い、発注履歴に入庫日を登録します。よろしいですか？"
    );
    if (enterConform) {
      try {
        const response = await fetch(`${baseUrl}/orderedenter`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            order_id: ordered[index].order_id,
          }),
        });
        const data = await response.json();
        if (data.isAuth === false) {
          alert("セッションが切れました。再度ログインしてください");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        if (data.success) {
          const response = await fetch(`${baseUrl}/submitentering`, {
            method: "PUT",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              order_id: ordered[index].order_id,
            }),
          });
          const data = await response.json();
          console.log(data.result);
          alert("入庫処理と入庫日の登録が完了しました。");
        }
        setReload(!reload);
      } catch (error) {
        alert("入庫処理に失敗しました。");
        console.error(error);
      }
    } else {
      alert("入庫処理と入庫日の登録をキャンセルしました。");
    }
  };

  const handleIndividualEntering = async (index: number, index2: number) => {
    const enterConform = window.confirm(
      "選択した未入庫分製品の入庫処理を行い、発注履歴に入庫日を登録します。よろしいですか？"
    );
    if (enterConform) {
      try {
        const enterproduct = ordered[index].products[index2];
        const response = await fetch(`${baseUrl}/orderedindividualenter`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            order_id: ordered[index].order_id,
            productname: enterproduct.productname,
            left_right: enterproduct.left_right,
            color: enterproduct.color,
            size: enterproduct.size,
            quantity: enterproduct.quantity,
          }),
        });
        const data = await response.json();
        if (data.isAuth === false) {
          alert("セッションが切れました。再度ログインしてください");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        if (data.success) {
          const response = await fetch(`${baseUrl}/submitindividualentering`, {
            method: "PUT",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              order_id: ordered[index].order_id,
              productname: ordered[index].products[index2].productname,
              color: ordered[index].products[index2].color,
              left_right: ordered[index].products[index2].left_right,
              size: ordered[index].products[index2].size,
              quantity: ordered[index].products[index2].quantity,
            }),
          });
          const data = await response.json();
          console.log(data.result);
          alert("入庫処理と入庫日の登録が完了しました。");
        }
        setReload(!reload);
      } catch (error) {
        alert("入庫処理に失敗しました。");
        console.error(error);
      }
    } else {
      alert("入庫処理と入庫日の登録をキャンセルしました。");
    }
  };

  return (
    <div className={styles.div}>
      <h2 className={styles.h2}>発注済み未入庫</h2>
      <label htmlFor="office">
        支店：
        <select
          id="office"
          onChange={handleOffice}
          value={selectedOffice}
          className={styles.select}
        >
          <option value="">未設定</option>
          <option value="函館店">函館店</option>
          <option value="札幌店">札幌店</option>
          <option value="釧路店">釧路店</option>
          <option value="室蘭店">室蘭店</option>
        </select>
      </label>
      <label htmlFor="supplier">
        発注先：
        <select
          id="supplier"
          onChange={handleSupplier}
          value={selectedSupplier}
          className={styles.select}
        >
          <option value="">未設定</option>
          {suppliers.map((item, index) => (
            <option value={item.supplier} key={index}>
              {item.supplier}
            </option>
          ))}
        </select>
      </label>
      <div className={styles.scroll}>
        {ordered.length > 0 ? (
          ordered.map((item: orderedData, index) => (
            <div key={index} className={styles.tableCard}>
              発注日：{item.order_at} 発注元：{item.office} 発注先：
              {item.supplier}
              <table key={index} className={styles.table}>
                <thead>
                  <tr>
                    <th className={styles.th}>製品名</th>
                    <th className={styles.th}>色</th>
                    <th className={styles.th}>左右</th>
                    <th className={styles.th}>サイズ</th>
                    <th className={styles.th}>数量</th>
                    <th className={styles.th}>入庫日</th>
                  </tr>
                </thead>
                <tbody>
                  {item.products.map((item2: product, index2) => (
                    <tr key={index2} className={styles.tr}>
                      <td className={styles.td}>{item2.productname}</td>
                      <td className={styles.td}>{item2.color}</td>
                      <td className={styles.td}>{item2.left_right}</td>
                      <td className={styles.td}>{item2.size}</td>
                      <td className={styles.td}>{item2.quantity}</td>
                      <td className={styles.td}>{item2.receiveDate}</td>
                      <td>
                        {" "}
                        <Button
                          size="small"
                          sx={{ margin: 0 }}
                          onClick={() =>
                            handleIndividualEntering(index, index2)
                          }
                          disabled={!(item2.receiveDate === "")}
                          variant="outlined"
                        >
                          個別に入庫する
                        </Button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={7}>
                      <Button
                        variant="contained"
                        onClick={() => orderedEnter(index)}
                      >
                        入庫
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))
        ) : (
          <p>条件の合う発注済み未入庫が見つかりません。</p>
        )}
      </div>
    </div>
  );
}
